// @ts-nocheck
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PostApi } from "../../../ApiClient/PostApi";
import { error_toaster, success_toaster } from "../../toaster/Toaster";

import { Loader2 } from "../../loader/Loader";
import { setLoginStatus } from "../../../Utils/AuthCheck";
export default function EmailOtp() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const verify_otp = async (event) => {
    event.preventDefault();

    if (otp === "") {
      error_toaster("Email is required!");
      return false;
    } else {
      setLoading(true);
      const res = await PostApi("users/verify_email", {
        email: localStorage.getItem("email"),
        otp: otp,
      });
      if (res.data.status === "1") {
        navigate("/");
        setLoading(false);
        setLoginStatus(true);
        localStorage.setItem("BearerToken", res.data.data.accessToken);
        localStorage.setItem("firstName", res.data.data.firstName);
        localStorage.setItem("lastName", res.data.data.lastName);
        localStorage.setItem("email", res.data.data.email);
        localStorage.setItem("userId", res.data.data.id);

        success_toaster(res.data.message);
      } else {
        setLoading(false);
        error_toaster(res.data.message);
      }
    }
  };
  const resend_otp = async (event) => {
    event.preventDefault();

    setLoading(true);
    const res = await PostApi("users/resend_otp", {
      email: localStorage.getItem("email"),
    });
    if (res.data.status === "1") {
      setLoading(false);
      success_toaster(res.data.message);
    } else {
      setLoading(false);
      error_toaster(res.data.message);
    }
  };
  const body = "body {background: #FFFFFF !important}";
  const inputStyle =
    "bg-themeGray border-none font-normal sm:text-xl text-lg px-5 py-3 rounded-lg placeholder:text-black placeholder:text-opacity-40 focus:outline-none";
  return (
    <>
      <style>{body}</style>
      <section className="grid lg:grid-cols-2 h-[100vh]">
        <div className="bg-themeBlue lg:py-12 py-4 lg:px-12 px-2 flex lg:flex-col items-center justify-center lg:gap-y-12">
          {/* <div className="lg:block hidden">
                        <img
                            src="/images/auth/cart.webp"
                            alt="cart"
                            className="xl:w-[440px] lg:w-80"
                        />
                    </div> */}
          <Link to={"/"} className="p-0">
            <img src="images/logo.webp" alt="logo" className="xl:w-60 w-52" />
          </Link>
          {/* <p className="font-normal xl:text-2xl lg:text-xl text-white text-center xl:w-4/5 mx-auto lg:block hidden">
            An email with otp has been send to your email{" "}
            {localStorage.getItem("email")}
          </p> */}
        </div>
        {loading ? (
          <Loader2 />
        ) : (
          <div className="xl:w-1/2 lg:w-3/4 md:w-1/2 sm:w-2/3 w-4/5 mx-auto flex flex-col justify-center gap-y-8">
            <h1 className="font-bold sm:text-5xl text-4xl">Verify OTP</h1>
            <p className="font-fiexen">
            An email containing an OTP has been sent to your email address{" "}
              {localStorage.getItem("email")}
            </p>
            <div className="flex flex-col gap-y-4">
              <input
                type="email"
                name="email"
                onChange={(e) => setOtp(e.target.value)}
                value={otp}
                placeholder="Enter OTP"
                className={inputStyle}
              />
            </div>

            <button
              onClick={verify_otp}
              className="bg-themeBlue text-white font-medium sm:text-xl text-lg py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-transparent hover:text-themeBlue"
            >
              Verify
            </button>

            <button
              onClick={resend_otp}
              className="bg-themeBlue text-white font-medium sm:text-xl text-lg py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-transparent hover:text-themeBlue"
            >
              Resend OTP
            </button>

            <Link
              to={"/register"}
              className="text-themeBlue font-medium sm:text-xl text-lg text-center py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-themeBlue hover:text-white"
            >
              Create new account
            </Link>
          </div>
        )}
      </section>
    </>
  );
}
